"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayWrapper = exports.ModalBody = exports.ContentWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styling = require("../utils/styling");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-1fskcyj-0"
})(["flex-grow:1;overflow-y:auto;", ""], function (props) {
  return props.withPadding && (0, _styledComponents.css)(["padding:30px;"]);
});
exports.ContentWrapper = ContentWrapper;
var ModalBody = _styledComponents["default"].div.withConfig({
  displayName: "styles__ModalBody",
  componentId: "sc-1fskcyj-1"
})(["display:flex;flex-direction:column;background-color:#fff;box-shadow:0 0 40px rgba(0,0,0,.5);max-height:100%;padding-bottom:20px;", " ", " ", " ", " ", " ", " @media screen and (max-width:1000px){max-width:100%;}@media screen and (max-width:768px){height:100vh;width:100vw;}&:focus{border-width:1px;border-style:solid;border-color:lightgray;}"], function (props) {
  return props.size === 'sm' && (0, _styledComponents.css)(["width:30%;"]);
}, function (props) {
  return props.size === 'md' && (0, _styledComponents.css)(["width:50%;max-width:1000px;"]);
}, function (props) {
  return props.size === 'lg' && (0, _styledComponents.css)(["width:60%;min-width:1000px;"]);
}, function (props) {
  return props.size === 'xl' && (0, _styledComponents.css)(["width:90%;height:90%;"]);
}, function (props) {
  return props.width && (0, _styledComponents.css)(["width:", ";"], (0, _styling.toPixels)(props.width));
}, function (props) {
  return props.height && (0, _styledComponents.css)(["height:", ";"], (0, _styling.toPixels)(props.height));
});
exports.ModalBody = ModalBody;
var OverlayWrapper = _styledComponents["default"].div.attrs({
  role: 'presentation'
}).withConfig({
  displayName: "styles__OverlayWrapper",
  componentId: "sc-1fskcyj-2"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.4);z-index:3000;"]);
exports.OverlayWrapper = OverlayWrapper;
//# sourceMappingURL=styles.js.map